import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IncrediSelect } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref, watch } from 'vue';
import { useWorkloadsTableConstants } from '@/views/workloads/workloads.const';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { Builds_BuildType } from '@/graphql/codegen/generated/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadTypeFilter',
  setup(__props) {

const workloadsConstants = useWorkloadsTableConstants();
const workloadTypeSelectOptions = computed(() => workloadsConstants.WORKLOAD_TYPE_SELECTION_OPTIONS);
const workloadsPageData = inject(IKWorkloadsPageData);
const modelValue = ref(workloadsPageData?.filter?.get?.value?.buildType as Builds_BuildType[]);
const handleSubmitFilter = () => {
  workloadsPageData?.filter?.setBuildType(modelValue.value);
};

const handleUpdateFilter = (selection: []) => {
  modelValue.value = selection;
  if (modelValue.value.length === 0) {
    handleSubmitFilter();
  }
};

watch(
  () => workloadsPageData?.filter?.get?.value?.buildType,
  (newValue: any) => {
    modelValue.value = newValue;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediSelect), {
        items: _unref(workloadTypeSelectOptions) as any,
        "model-value": modelValue.value as any,
        size: "tiny",
        design: "ghost",
        direction: "bottom-sticky-left",
        label: "Build Type",
        multiple: "",
        clearable: "",
        "list-min-width": 136,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (item) => handleUpdateFilter(item)),
        onSubmit: handleSubmitFilter
      }, null, 8, ["items", "model-value"])
    ]),
    _: 1
  }))
}
}

})